


import "./polyfills/NodeList.forEach";

import animations from "./_animations";
import cloudImages from "./_cloudinary";
import quoteMedia from "./_quotemedia";
import nav from "./_nav";
import subnav from "./_subnav";
import phoneSlider from "./_phone-slider";
import dailyMarket from "./_daily-market";
import investmentTypes from "./_investment-types";
import annuitiesTable from "./_annuities-table";
import videoModal from "./_video-modal";
import cloudinaryVideoModal from "./_cloudinary-video-modal";
import loginModal from "./_login-modal";
// import salesforceModal from "./_live-chat-modal";
import tabs2Col from "./_tabs-2col";
import formValidate from "./_form-validate";
import alertBanners from "./_alert-banner";
// import liveChat from "./_live-chat";


console.log('NODE_ENV', process.env.NODE_ENV);
console.log('TRADER_URL', process.env.TRADER_URL);
console.log('REGISTER_URL', process.env.REGISTER_URL)
console.log('API_URL', process.env.API_URL)

// prevent menu cache on ios
window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};

window.addEventListener("load", (event) => {
  animations();
});

document.addEventListener(
  "DOMContentLoaded",
  function () {

    formValidate();
    cloudImages();
    quoteMedia();
    
    if (document.querySelector('.main-nav') != null) {
      nav();
    }

    subnav();
    tabs2Col();
    phoneSlider();
    dailyMarket();
    investmentTypes();
    annuitiesTable();
    videoModal();
    cloudinaryVideoModal();

    if (document.querySelector('.login-modal') != null) {
      loginModal();
    }
    
    // salesforceModal();
    alertBanners();
    // liveChat();


    // setup hubspot form in footer area
    var myHubspot = document.querySelector('.footer__newsletter-form-hubspot');

    if (myHubspot != null) {
      var myScript = document.createElement("script");
      myScript.innerHTML = 'hbspt.forms.create({region: "na1",portalId: "21128494",formId: "8c7814de-486b-4a8e-9b36-db5030233062"});';
      myHubspot.parentNode.replaceChild(myScript, myHubspot);
    }


    // animate fade out
    document.addEventListener("animationend", function (e) {
      if (e.animationName === "fadeOut") {
        e.target.classList.remove("fade-out");
      }
    });

    // smooth scroll anchors
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        if (this.classList.contains("no-jump")) {
          e.preventDefault();
        } else {
          if (!this.classList.contains("no-animate")) {
            e.preventDefault();

            /*document.querySelector(this.getAttribute('href')).scrollIntoView({
  	          behavior: 'smooth'
  	      });*/

            const id = this.getAttribute("href");
            const yOffset = -100;
            const element = document.querySelector(id);
            const y =
              element.getBoundingClientRect().top +
              window.pageYOffset +
              yOffset;

            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }
      });
    });

    // back to top
    document.querySelectorAll(".back-to-top > div").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
    });

    // make hight of iframes 100%
    if (typeof iFrameResize !== "undefined") {
      iFrameResize({ log: false }, ".iframe-resize");
    }

    // newsletter form
    var newsletterFormBtn = document.querySelector(
      ".footer__newsletter-form .btn"
    );

    if (newsletterFormBtn != null) {
      newsletterFormBtn.addEventListener("click", function (e) {
        e.preventDefault();

        var form = document.getElementsByClassName("footer__newsletter-form")[0];

        var constraints = {
          email: {
            presence: true,
            email: true,
          },
        };

        var formError = form.querySelector(".input-group__error");
        var errors = validate(form, constraints);

        if (errors) {
          formError.innerHTML = errors.email[0];
          formError.classList.add("has-error", "input-group__error--dark");
        } else {
          formError.innerHTML = "";
          formError.classList.remove("has-error");
          // submit

          var email = document.getElementById("footer__newsletter-form-email");

          var httpRequest = new XMLHttpRequest();

          httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState === XMLHttpRequest.DONE) {
              // show success message
              if (httpRequest.status === 201) {
                // remove any previous error messages
                formError.innerHTML = "";
                formError.classList.remove("has-error");

                // replace email field with success message
                var p = document.createElement("p");
                p.innerHTML = "Thanks for signing up!";
                p.className = "footer__newsletter-form-success";

                // add success / error message to DOM
                email.parentNode.replaceChild(p, email);

                // disable submit button on success
                var btn = form.querySelector("button");
                btn.disabled = true;
              } else if (httpRequest.status === 400) {
                var p = document.createElement("p");
                if (httpRequest.statusText) {
                  var json = JSON.parse(httpRequest.statusText);
                  // error code for invalid email address
                  if (json.Code && json.Code === 1) {
                    formError.innerHTML = "This is not a valid email address.";
                  } else if (json.Code && (json.Code === 204 || json.Code === 205 || json.Code === 206 || json.Code === 207 || json.Code === 208)) {
                    /**
                     * email address is on a list that makes it so it cannot sign
                     * up for mailing list (deleted, unsubscribed, bounced, etc.)
                     */
                    formError.innerHTML = "Sorry, you cannot sign up with this email address.";
                  } else {
                    // default error message
                    formError.innerHTML = "Sorry there was an error, please try again later";
                  }
                }
                // set error css class for error message
                formError.classList.add("has-error", "input-group__error--dark");
              } else {
                // generic default error
                formError.classList.add("has-error", "input-group__error--dark");
                formError.innerHTML = "Sorry there was an error, please try again later";
              }
            }
          };

          httpRequest.open("POST", "/campaign/create");
          httpRequest.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded"
          );
          httpRequest.send("Email=" + encodeURIComponent(email.value));
        }
      });
    }
    

    // investor relations shareholder updates
    var shareholderSignupBtn = document.querySelector("#shareholderUpdatesSignupBtn");
    if (shareholderSignupBtn) {
      shareholderSignupBtn.addEventListener("click", function (e) {
        console.log('signup click');
        e.preventDefault();
        var form = document.getElementsByClassName("investment-text-image__form")[0];
        var constraints = {
            email: {
                presence: true,
                email: true
            }
        };
        var formError = form.querySelector(".investment-text-image__form-error");
        var errors = validate(form, constraints);


        if (errors) {
            formError.innerHTML = errors.email[0];
            formError.classList.add("has-error");
        } else {
            formError.innerHTML = "";
            formError.classList.remove("has-error");


            // submit
            console.log('subbmitting');

            var xhr = new XMLHttpRequest();
            xhr.open("POST", '/Campaign/ShareholderUpdates', true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            xhr.onreadystatechange = function() { // Call a function when the state changes.
                if (this.readyState === XMLHttpRequest.DONE) {
                  if (this.status === 201) {
                      var p = document.createElement("p");
                      p.innerHTML = "Thanks for signing up!";

                      var formFields = form.querySelector(".investment-text-image__form-fields");
                      formFields.parentNode.replaceChild(p, formFields); // disable submit button on success
                  }
                  else {
                      var p = document.createElement("p");
                      p.innerHTML = "Sorry there was an error, please try again later";

                      var formFields = form.querySelector(".investment-text-image__form-fields");
                      formFields.parentNode.replaceChild(p, formFields); // disable submit button on success
                  }
                }
            }
            

            var name = document.getElementById("investment-text-image__form-name");
            var email = document.getElementById("investment-text-image__form-email");
            var account = document.getElementById("investment-text-image__form-account");
            xhr.send("Name=" + encodeURIComponent(name.value) + "&Email=" + encodeURIComponent(email.value) + "&Account=" + encodeURIComponent(account.value));
        }
      });
    }

    // investor news updates
    var investorNewsSignupBtn = document.querySelector("#investorNewsSignupBtn");
    if (investorNewsSignupBtn) {
      investorNewsSignupBtn.addEventListener("click", function (e) {
        console.log('signup click');
        e.preventDefault();
        var form = document.getElementsByClassName("investor-news-panel__form")[0];
        var constraints = {
            email: {
                presence: true,
                email: true
            }
        };
        var formError = form.querySelector(".investor-news-panel__form-error");
        var errors = validate(form, constraints);


        if (errors) {
            formError.innerHTML = errors.email[0];
            formError.classList.add("has-error");
        } else {
            formError.innerHTML = "";
            formError.classList.remove("has-error");


            // submit
            console.log('subbmitting');

            var xhr = new XMLHttpRequest();
            xhr.open("POST", '/Campaign/ShareholderUpdates', true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            xhr.onreadystatechange = function() { // Call a function when the state changes.
                if (this.readyState === XMLHttpRequest.DONE) {
                  if (this.status === 201) {
                      var p = document.createElement("p");
                      p.innerHTML = "Thanks for signing up!";

                      var formFields = form.querySelector(".investor-news-panel__form-fields");
                      formFields.parentNode.replaceChild(p, formFields); // disable submit button on success
                  }
                  else {
                      var p = document.createElement("p");
                      p.innerHTML = "Sorry there was an error, please try again later";

                      var formFields = form.querySelector(".investor-news-panel__form-fields");
                      formFields.parentNode.replaceChild(p, formFields); // disable submit button on success
                  }
                }
            }
            

            var name = document.getElementById("investor-news-panel__form-name");
            var email = document.getElementById("investor-news-panel__form-email");
            xhr.send("Name=" + encodeURIComponent(name.value) + "&Email=" + encodeURIComponent(email.value));
        }
      });
    }

    // google map
    var mapContainer = document.querySelectorAll(".google-map");
    mapContainer.forEach((el) => {
      el.addEventListener("click", function (event) {
        el.querySelector("iframe").classList.add("clicked");
      });
      el.addEventListener("mouseleave", function (event) {
        el.querySelector("iframe").classList.remove("clicked");
      });
    });

    // 4 step accordion image block
    var imageBlockMenuItems = document.querySelectorAll(
      ".image-menu-block__content"
    );
    imageBlockMenuItems.forEach((el) => {
      el.addEventListener("click", function (event) {
        event.preventDefault();

        var visible = document.getElementsByClassName(
          "image-menu-block__menu-item--visible"
        )[0];
        visible.classList.remove("image-menu-block__menu-item--visible");

        var visibleImage = document.getElementsByClassName(
          "image-menu-block__image--visible"
        )[0];
        visibleImage.classList.remove("image-menu-block__image--visible");

        var parent = el.parentElement;
        parent.classList.add("image-menu-block__menu-item--visible");

        var image = el.dataset.image;

        var imageElem = document.getElementsByClassName(
          "image-menu-block__image-" + image
        )[0];
        imageElem.classList.add("image-menu-block__image--visible");
      });
    });
  },
  false
);
